module.exports = __webpack_public_path__ + "img/7.4aaed7a8.jpg";